import type { ReactNode } from 'react'
import { ConfirmDialogHost } from './confirm-dialog'
import { NavSidebar } from './nav-sidebar'
import { AdminToastContainer } from './toast'

/**
 * App shell: navy sidebar on the left, content area on the right.
 * Wraps the buzola <Outlet/> in application.tsx.
 */
export function AdminLayout({ children }: { children: ReactNode }) {
	return (
		<div className="flex min-h-screen bg-bg-gray">
			<NavSidebar />
			<main className="flex-1 min-w-0">
				<div className="max-w-screen-2xl mx-auto px-4 md:px-8 py-6 md:py-8">
					{children}
				</div>
			</main>
			<AdminToastContainer />
			<ConfirmDialogHost />
		</div>
	)
}
